export interface IModelApplicationResponse {
  id: number;
  name: string;
  description: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  status: string;
  smsConfigurationId: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelApplication {
  id: number;
  name: string;
  description: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  status: string;
  smsConfigurationId: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;

  constructor(props = {} as IModelApplicationResponse) {
    props = props ?? {}
    this.id = props.id;
    this.name = props.name;
    this.description = props.description;
    this.clientId = props.clientId;
    this.clientSecret = props.clientSecret;
    this.redirectUri = props.redirectUri;
    this.status = props.status;
    this.smsConfigurationId = props.smsConfigurationId;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }
}


export interface IModelApplicationScopeRelation {
  createdAt: string | Date;
  updatedAt: string | Date;
  applicationId: number;
  scopeMasterId: number;
}

export interface IModelScope {
  id: number;
  name: string;
  scope: string;
  hostName: string | null;
  urlPath: string | null;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  applicationScopeRelations: IModelApplicationScopeRelation;
}

export interface IModelSMSConfiguration {
  id: number;
  name: string;
  service: string;
  apiKey: string;
  secretKey: string;
  sender: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface IModelRolePermissionRelation {
  createdAt: string | Date;
  updatedAt: string | Date;
  roleId: number;
  permissionId: number;
}

export interface IModelPermission {
  id: number;
  name: string;
  permission: string;
  status: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  role_permission_relations: IModelRolePermissionRelation;
}

export interface IModelRole {
  id: number;
  applicationId: number;
  name: string;
  status: string;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  application_id: number;
  permissions: IModelPermission[];
}

export interface IModelApiKey {
  id: number;
  applicationId: number;
  name: string;
  apiKey: string;
  isShowApiKey?: boolean;
}

export interface IModelApiKeyResponse extends IModelApiKey {
  lastUsedAt?: string | Date;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelApplicationApiKey {
  id: number;
  applicationId: number;
  name: string;
  apiKey: string;
  lastUsedAt?: string | Date;
  createdAt: string | Date;
  updatedAt: string | Date;
  isShowApiKey: boolean = false;

  constructor(props: IModelApiKeyResponse = {} as IModelApiKeyResponse) {
    this.id = props.id;
    this.applicationId = props.applicationId;
    this.name = props.name;
    this.apiKey = props.apiKey;
    this.lastUsedAt = props.lastUsedAt;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.isShowApiKey = props.isShowApiKey ?? false;
  }
}

export interface IModelApplicationAsso {
  id: number;
  name: string;
  description: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  status: string;
  smsConfigurationId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  sms_configuration_id: number;
  scopes: IModelScope[];
  smsConfiguration: IModelSMSConfiguration;
  roles: IModelRole[];
  apiKeys: IModelApiKey[];
}

export class ModelApplicationAsso {
  id: number;
  name: string;
  description: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  status: string;
  smsConfigurationId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  sms_configuration_id: number;
  scopes: IModelScope[];
  smsConfiguration: IModelSMSConfiguration;
  roles: IModelRole[];
  apiKeys: IModelApiKey[];

  constructor(props: IModelApplicationAsso = {} as IModelApplicationAsso) {
    this.id = props.id;
    this.name = props.name;
    this.description = props.description;
    this.clientId = props.clientId;
    this.clientSecret = props.clientSecret;
    this.redirectUri = props.redirectUri;
    this.status = props.status;
    this.smsConfigurationId = props.smsConfigurationId;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.sms_configuration_id = props.sms_configuration_id;
    this.scopes = props.scopes || [];
    this.smsConfiguration = props.smsConfiguration;
    this.roles = props.roles?.map(role => ({
      ...role,
      permissions: role.permissions || [],
    })) || [];
    this.apiKeys = props.apiKeys || [];
  }
}





export interface ImodeApplicationData {
  name: string;
  description: string;
  redirectUri: string;
  status: string;
}

export interface ImodeSMSConfig {
  name: string;
  service: string;
  apiKey: string;
  secretKey: string;
  sender: string;
}

export interface ImodePermissionData {
  name: string;
  permission: string;
  status: string;
}

export interface ImodeRoleData {
  name: string;
  status: string;
  type: string;
  permissions: ImodePermissionData[];
}

export interface ImodeApplicationRequest {
  application: ImodeApplicationData;
  scopes: number[];
  smsConfig: ImodeSMSConfig;
  roles: ImodeRoleData[];
}
